import React, { useState } from "react";
import "./addressCard.scss";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Skeleton,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";

const AddressCardSkeleton = () => {
  return (
    <div className="address-card">
      <div className="main-title">
        <Skeleton animation="wave">
          <div className="customer-name">customer-name</div>
        </Skeleton>
        <Skeleton animation="wave" sx={{ ml: 1 }}>
          <div className="address-category">(address-category)</div>
        </Skeleton>
      </div>
      <div className="customer-address">
        <Skeleton animation="wave" width="100%" />
        <Skeleton animation="wave" width="50%" />
      </div>
      <div className="contact-no-and-btn">
        <Skeleton animation="wave">
          <p>1234567890</p>
        </Skeleton>

        <div className="delete-delivery-edit-btn-container">
          <div className="delete-address-btn">
            <Skeleton animation="wave">
              <Button className="btn">
                <p>Delete</p>
              </Button>
            </Skeleton>
          </div>
          <div className="deliver-address-btn">
            <Skeleton animation="wave">
              <Button className="btn" variant="outlined">
                <p>Edit</p>
              </Button>
            </Skeleton>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddressCardSkeleton;
